import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import useStyles from './styles';

function ErrorModal({ open, title, message, onClose }) {
  const classes = useStyles();

  return (
    <Dialog
      aria-labelledby="dialog-error-modal"
      maxWidth="xs"
      onClose={onClose}
      open={open}
    >
      <DialogTitle id="dialog-error-modal" className={classes.dialogTitle}>
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <p>{message}</p>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          className={classes.dialogButton}
          onClick={onClose}
          variant="contained"
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ErrorModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

ErrorModal.defaultProps = {
  title: 'Error',
};

export default ErrorModal;
